import { render } from "./VolunteerDetails.view.vue?vue&type=template&id=48887e2a"
import script from "./VolunteerDetails.view.vue?vue&type=script&lang=js"
export * from "./VolunteerDetails.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__